import { render, staticRenderFns } from "./sub-head.vue?vue&type=template&id=3c12fd88&scoped=true&"
import script from "./sub-head.vue?vue&type=script&lang=js&"
export * from "./sub-head.vue?vue&type=script&lang=js&"
import style0 from "./sub-head.vue?vue&type=style&index=0&id=3c12fd88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12fd88",
  null
  
)

export default component.exports